import 'reflect-metadata';
import { plainToClass } from "class-transformer";
import { DrawCabinet } from '$src/CGS/domain/dto/article/Cabinet/DrawCabinet';
import { CabinetGeneratorFactory } from '../../Cabinet/CabinetGeneratorFactory ';
import { CabinetObject } from '../../Cabinet/Objects/CabinetObject';

export class CabinetS1Test {

    private jsonData = {
        "$id": "1",
        "CabinetShape": {
            "Depth": "561",
            "Height": "720",
            "Orientation": 3,
            "TypeName": "DrawS1CabinetShape",
            "Width": "600"
        },
        "Constants": {
            "$id": "2",
            "BoxThickness": "16",
            "CountertopHeight": "720",
            "DoorThickness": "20",
            "DrawerRailHeight": "100",
            "DrawerRecess": "100",
            "FixedShelfThickness": "16",
            "GapBetweenFrontElements": "3",
            "GapBottomBox": "0",
            "GapTopBox": "0",
            "GlassShelfThickness": "6",
            "GrooveGap": "30",
            "GrooveWidth": "60",
            "IsDefaultHeightConstant": true,
            "PlinthDepth": "60",
            "PlinthHeight": "150",
            "PulloutRailHeight": "200",
            "PulloutRecess": "100",
            "ShelfThickness": "16",
            "SideBoxGap": "3"
        },
        "ElementSubType": {
            "$id": "12",
            "Id": "8e5505c3-1bb0-44a1-b0f4-f80b3acc7457",
            "Name": "CabinetBox"
        },
        "Fronts": [
            {
                "$id": "3",
                "Element": {
                    "$id": "5",
                    "FrontElement": 1,
                    "Height": "717",
                    "Inside": {
                        "$id": "6",
                        "Anchor": {
                            "$id": "8",
                            "AnchorType": 8
                        },
                        "Depth": "Auto",
                        "Face": {
                            "$id": "7",
                            "Index": 2
                        },
                        "Height": "Auto",
                        "IsFixed": true,
                        "Material": 3,
                        "Offset": {
                            "$id": "9",
                            "OffsetType": 2
                        },
                        "Type": 4,
                        "TypeName": "DrawInsideShelf",
                        "Width": "Auto"
                    },
                    "OpeningOrientation": 0,
                    "OpeningType": 0,
                    "TypeName": "DrawFrontDoor",
                    "Width": "Auto"
                },
                "Faces": [
                    {
                        "$id": "4"
                    }
                ]
            }
        ],
        "Id": "cc2562a4-e85e-4aab-aa38-aea386212ade",
        "ProviderRef": "UD 60",
        "Range": {
            "$id": "10",
            "HasHandles": true,
            "Id": "d694304c-d0db-4002-9da3-ae098bffe533",
            "IsWithGaps": true,
            "Name": "Classic"
        },
        "Shape": {
            "$id": "13",
            "Depth": "561",
            "Height": "720",
            "Orientation": 3,
            "TypeName": "DrawS1CabinetShape",
            "Width": "600"
        },
        "SubFinish": {
            "$id": "11",
            "Id": "a5a21e47-3cde-4916-a502-9abe55d7bbf8"
        },
        "TypeName": "DrawCabinet"
    };


    getCabinet() : CabinetObject | undefined {
        let drawCabinet = this.getDrawCabinet();

        const generator = CabinetGeneratorFactory.GetGenerator(drawCabinet);
        const cabinetObject = generator?.BuildCabinet();

        return cabinetObject;
    }

    getDrawCabinet(): DrawCabinet {

        const deserializedObject = plainToClass(DrawCabinet, this.jsonData);

        return deserializedObject;
    }

}